import { Skeleton } from '../Kit/_index';

const BLOCK = 'LStudio__app_detail';

/*
    🔥 VISTA DE DETALLE — EL PAR DEL FORMULARIO

    Mostrar un registro en modo lectura. Sin esto, todo CRUD termina
    reusando el formulario con los campos deshabilitados, y un input
    gris con borde le sigue diciendo al usuario "esto se edita" cuando
    no se edita.

    ⚠️ UN VALOR VACÍO SE MUESTRA, NO SE ESCONDE

    Si el campo desaparece cuando no tiene dato, dos registros del
    mismo tipo se ven distintos y el usuario no sabe si el dato falta
    o si nunca existió ese campo. Va el guión largo.

    ⚠️ EL SKELETON RESPETA LA CANTIDAD DE FILAS

    Con isLoading la vista mantiene la misma altura que va a tener con
    datos. Si no, la pantalla salta cuando llega la respuesta.
*/

export const DetailItem = ({
    label,
    value = null,
    icon = null,
    span = 1,                    // cuántas columnas ocupa
    isLoading = false,
    isEmphasis = false,          // valor grande: el importe, el total
    children = null,
}) => {

    const CONTENT = children ?? value;

    const IS_EMPTY = CONTENT === null || CONTENT === undefined || CONTENT === '';

    return (
        <div className={`${BLOCK}__item`} data-span={span} data-emphasis={isEmphasis}>

            <span className={`${BLOCK}__label`}>
                {icon && <span className={`${BLOCK}__label_icon`} aria-hidden="true">{icon}</span>}
                {label}
            </span>

            {
                isLoading
                    ? <Skeleton width="70%" />
                    : (
                        <span className={`${BLOCK}__value`} data-empty={IS_EMPTY}>
                            {IS_EMPTY ? '—' : CONTENT}
                        </span>
                    )
            }

        </div>
    );
};

export const DetailSection = ({
    title = null,
    description = null,
    actions = null,
    columns = 2,                 // 1 | 2 | 3 | 4
    children,
}) => (

    <section className={`${BLOCK}__section`}>

        {
            (title || actions) && (
                <header className={`${BLOCK}__section_head`}>

                    <div>
                        {title && <h3 className={`${BLOCK}__section_title`}>{title}</h3>}
                        {description && <p className={`${BLOCK}__section_desc`}>{description}</p>}
                    </div>

                    {actions && <div className={`${BLOCK}__section_actions`}>{actions}</div>}

                </header>
            )
        }

        {/*
            ⚠️ La cantidad de columnas viaja inline, igual que en
               MetricGrid: el responsive pisa grid-template-columns
               directamente. Ver _GridGuard.css.
        */}
        <div className={`${BLOCK}__grid`} style={{ '--LS__detail_cols': columns }}>
            {children}
        </div>

    </section>
);

export const DetailView = ({
    title = null,
    subtitle = null,
    status = null,               // <StatusBadge/> u otro nodo
    actions = null,
    aside = null,                // columna lateral: metadatos, historial
    variant = 'surface',         // surface | plain
    children,
}) => (

    <article className={BLOCK} data-variant={variant} data-has-aside={!!aside}>

        {
            (title || actions || status) && (
                <header className={`${BLOCK}__head`}>

                    <div className={`${BLOCK}__head_text`}>

                        <div className={`${BLOCK}__head_title_row`}>
                            {title && <h2 className={`${BLOCK}__title`}>{title}</h2>}
                            {status}
                        </div>

                        {subtitle && <p className={`${BLOCK}__subtitle`}>{subtitle}</p>}

                    </div>

                    {actions && <div className={`${BLOCK}__actions`}>{actions}</div>}

                </header>
            )
        }

        <div className={`${BLOCK}__body`}>

            <div className={`${BLOCK}__main`}>{children}</div>

            {aside && <aside className={`${BLOCK}__aside`}>{aside}</aside>}

        </div>

    </article>
);
